import { z } from "zod";
import { CoursePackageNameEnum } from "./course.js";
export const CreateCheckoutPayloadSchema = z.object({
    course_id: z.number(),
    package_name: CoursePackageNameEnum,
    success_url: z.string().url(),
    cancel_url: z.string().url(),
});
export const CheckoutSessionSchema = z.object({
    session_id: z.string(),
    url: z.string().url(),
});
export const PaymentStatusSchema = z.object({
    status: z.enum(["complete", "expired", "open"]),
    payment_status: z.string(),
    course_id: z.number().nullable(),
});
// Subscription types
export const SubscriptionTierEnum = z.enum(["FREE", "PREMIUM"]);
export const SubscriptionStatusEnum = z.enum(["active", "canceled", "past_due", "incomplete", "trialing"]);
export const BillingIntervalEnum = z.enum(["month", "year"]);
export const SubscriptionSchema = z.object({
    tier: SubscriptionTierEnum,
    status: SubscriptionStatusEnum.optional(),
    stripe_customer_id: z.string().optional(),
    stripe_subscription_id: z.string().optional(),
    billing_interval: BillingIntervalEnum.optional(),
    current_period_end: z.string().optional(),
    cancel_at_period_end: z.boolean().optional(),
});
export const CreateSubscriptionCheckoutSchema = z.object({
    billing_interval: BillingIntervalEnum,
    success_url: z.string().url(),
    cancel_url: z.string().url(),
});
export const SubscriptionStatusResponseSchema = z.object({
    tier: SubscriptionTierEnum,
    status: SubscriptionStatusEnum.optional(),
    billing_interval: BillingIntervalEnum.optional(),
    current_period_end: z.string().optional(),
    cancel_at_period_end: z.boolean().optional(),
});
